import { Helmet } from "react-helmet";
import NavBar from './components/Navbar.js';
import Home from './components/Home.js'
import About from './components/About.js';
import Skills from './components/Skills.js'
import Qualification from './components/Qualification.js'
import Projects from './components/Project.js'
import SocialMedia from './components/Social-media.js';
import Contact from './components/Contact.js'

import './css/Common-style.css'
import AOS from 'aos';

AOS.init();

function App() {
  return (
    <>
    <Helmet>
      <title>N Giridhara Holla | Web Developer</title>
    <meta
      name="description"
      content="A Web Development enthusiast who is capable og using his  technical skills for the betterment of the organization. 
                            Fine practical knowledge and working experience with C, Python, JavaScript HTML5, CSS3, ReactJS, Nodejs, Mysql and Mongodb."
    />

    <meta name='keywords' content="N Giridhar Holla Portfolio HTML CSS Javascript ReactJS Nodejs Mysql Mongodb"/>

    <meta
      name="keywords"
      content="N Giridhara Holla Portfolio React-website"
    />

    <meta name="author" content="N Giridhara Holla"/>
    <meta name="robots" content="index,follow"/>

    <meta property="og:title" content="N Giridhara Holla - Portfolio" />
    <meta property="og:description" content="Fine practical knowledge and working experience with C, Python, JavaScript HTML5, CSS3, ReactJS, Nodejs, Mysql and Mongodb" />
    <meta property="og:image" content="../images/og-image.PNG" />
    <meta property="og:url" content="https://n-giridhara-holla.netlify.app"/>
    <meta property="og:type" content="website"/>
    </Helmet>
     <NavBar/>
     <Home/> 
     <About/>
     <Skills/>
     <Qualification/>
     <Projects/>
     <SocialMedia/>
     <Contact/>
    </>
  );
}

export default App;
